import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScrooollTableWaslRemembe from "./ScrooollTableWaslRemembe";
import FooterOfParayWasl from "./FooterOfParayWasl";
import FillDetailWaslRemembe from "./FillDetailWaslRemembe";
const AllWaslRemembe = () => {
  return (
    <div>
      <Navbar />
      <div style={{ marginTop: "50px" }}>
        <div className="row" style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 ">
            <FillDetailWaslRemembe />
          </div>
        </div>
        <div className="row">
          <div className="col-12 ">
            <ScrooollTableWaslRemembe />
          </div>
        </div>
        <div className="row " style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 col-12">
            <FooterOfParayWasl />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllWaslRemembe;
